import camelCase from 'lodash/camelCase';

export const REGEX_PHONE = /^(?:\+?[1-9]\d{1,14}|0\d{9}|(?:\+33|0033)\d{9})$/;
export const REGEX_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const REGEX_LINK = /(http|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@'!?^=%&:\\/~+#-]*[\w@?'!^=%&\\/~+#-])/gm;
// French SIV plate typed with or without its separators: "AA-123-AA", "AA123AA", "aa 123 aa"
export const REGEX_REGISTRATION_SIV = /^([A-Za-z]{2})[\s-]*(\d{3})[\s-]*([A-Za-z]{2})$/;
// Old FNI plate (before 2009), the department number closing it: "123-ABC-75", "9999 ZZ 2A"
export const REGEX_REGISTRATION_FNI = /^(\d{1,4})[\s-]*([A-Za-z]{1,3})[\s-]*(2[AaBb]|\d{2,3})$/;

export default class StringUtils {
    static upperFirst(label: string) {
        let res = label;
        if (label && typeof label === 'string') {
            res = label.charAt(0).toUpperCase() + label.slice(1);
        }
        return res;
    }

    static uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }

    static camelCase(str) {
        return camelCase(str);
    }

    static userFullname(user: { [key: string]: any; firstname: string; lastname: string; fullname?: string }) {
        if (!user) {
            return '';
        }
        if (user.fullname) {
            return user.fullname;
        }
        return [user.firstname, user.lastname].filter(Boolean).join(' ');
    }

    // Lowercase + strip diacritics, for accent-insensitive search/compare (e.g. "é" -> "e").
    static normalizeForSearch(str: any): string {
        return String(str ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    // Plates are stored dash separated: rebuild that format when the separators are
    // missing so an exact search still matches. A leading digit means the old FNI
    // plate (123-ABC-75), letters the SIV one (AA-123-AA). Anything else (foreign
    // plate, partial input) is left untouched.
    static formatRegistrationNumber(value: string): string {
        const plate = String(value ?? '').trim();
        const match = (/^\d/.test(plate) ? REGEX_REGISTRATION_FNI : REGEX_REGISTRATION_SIV).exec(plate);
        if (!match) {
            return value;
        }
        return `${match[1]}-${match[2]}-${match[3]}`.toUpperCase();
    }

    static isValidRegex(str: string): boolean {
        try {
            new RegExp(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    // Format a number to a string with 2 decimal places, removing trailing zeros
    static formatTimeNumber(str: number): string {
        return str.toFixed(2).replace(/\.?00$/, '');
    }

    static formatDocumentData(data: string): string {
        return data.replace(/\//g, '-');
    }
}
